import axios from "@/axios/axios";

export const doUpload = (chunk, requestHeader, requestURL) => {
    return new Promise((resolve, reject) => {
        putFile(chunk.file, requestHeader, requestURL).then(resp => {
            resolve(resp)
        })
    })
}

export const putFile = (chunk, requestHeader, requestURL, onprogress,onerror) => {
    function createXHR() {
        return window.XMLHttpRequest ?
            new XMLHttpRequest() :
            new ActiveXObject("Microsoft.XMLHTTP");
    }

    console.log("开始上传...")
    return new Promise((resolve, reject) => {

        // 获取到 U rl 后，前端可以这样 ajax 上传
        let xhr = createXHR();
        // put上传
        xhr.open('PUT', requestURL, true);　　// 请求头
        for (const splitElement of requestHeader.split('&')) {
            const key = splitElement.split('=')[0]
            xhr.setRequestHeader(key, splitElement.match(/=(.*)/)[1]);
        }
        xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
        xhr.ontimeout = function () {
            console.log("请求超时.");
            reject("请求超时")
        }
        xhr.upload.onprogress = function (evt) {
            if (onprogress) {
                onprogress(evt)
            }
        }
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    resolve()
                } else {
                    console.log("Error", xhr.statusText);
                    reject(xhr.statusText)
                    if(onerror){
                        onerror(xhr.statusText)
                    }
                }
            }
        };
        xhr.send(chunk.blobData); // files 是要上传的文件对象
    })
}